// Internal Imports
import BaseCommand from "./baseCommand";
import { AmplitudeUtils } from "../utils";
import { EVENTS, DOCUMENTS } from "../constants";
import { updateDocSignatories } from "../actions/DocumentActions/services";

// Destructuring
const { DOCUMENT_MODE } = DOCUMENTS;
const { amplitudeLogEvent } = AmplitudeUtils;

class DeleteSignBlockCommand extends BaseCommand {
  constructor(componentData) {
    super();
    this.componentData = componentData;
    this.preventNukeActiveState = true;
  }

  execute() {
    const {
      mode,
      sectionDataForSignature,
      deleteDocSignerSection,
      docId,
      signerIndex,
      signBlocks,
      onSectionUpdate,
      setState,
      signatories,
    } = this.componentData;

    const newSignBlocks = [...signBlocks];
    const signerConfigInfo = [];
    if (newSignBlocks) {
      newSignBlocks[signerIndex].signer_config.options.forEach(data => {
        if (data.checked) {
          signerConfigInfo.push(data.id);
        }
      });
    }

    const deleteSigner = [
      {
        component_id: sectionDataForSignature.id,
        ids: [newSignBlocks[signerIndex].id],
      },
    ];

    newSignBlocks.splice(signerIndex, 1);
    if (mode === DOCUMENT_MODE.DOCUMENT) {
      deleteDocSignerSection(deleteSigner, docId, newSignBlocks);

      const updatedSignatories = JSON.parse(JSON.stringify(signatories));
      updatedSignatories.forEach(signer => {
        if (signer.component_id === sectionDataForSignature.id) {
          signer.signers = newSignBlocks;
        }
      });
      this.componentData.updateActiveSignatureData(
        newSignBlocks,
        updatedSignatories,
        sectionDataForSignature.id,
      );
    }

    if (mode === DOCUMENT_MODE.TEMPLATE)
      onSectionUpdate([], false, newSignBlocks);
    setState({
      signBlocks: newSignBlocks,
    });
    amplitudeLogEvent(EVENTS.EVENT_NAMES.SIGNER_DELETED, {
      Signercount: Array.isArray(newSignBlocks) ? newSignBlocks.length : null,
      SignatureFieldsActive: signerConfigInfo,
    });
  }

  async undo() {
    const {
      mode,
      setState,
      signBlocks,
      signerIndex,
      onSectionUpdate,
      sectionDataForSignature,
      docId,
      signatories,
      updateDocSignatoriesAction,
    } = this.componentData;

    const newSignBlocks = [...signBlocks];
    const newSigner = signBlocks[signerIndex];
    if (mode === DOCUMENT_MODE.TEMPLATE) {
      await setState({
        signBlocks: newSignBlocks,
      });
      onSectionUpdate(newSigner[0], false, newSignBlocks);
    } else {
      const updatedSignerData = [
        {
          component_id: sectionDataForSignature.id,
          signers: [...newSignBlocks],
        },
      ];
      await updateDocSignatories(updatedSignerData, docId);
      updateDocSignatoriesAction(signatories);
      await setState({
        signBlocks: newSignBlocks,
      });
    }
  }
}

export default DeleteSignBlockCommand;



// WEBPACK FOOTER //
// ./src/commands/deleteSignBlockCommand.js